import { Cell, Grid, HFlow, InfoLabel, Tag } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { css } from 'emotion'
import { TipoGrupoParticipanteAtividadeColetivaEnum } from 'graphql/types.generated'
import React from 'react'

import {
  AtividadeColetivaGruposModel,
  atividadeColetivaTipoGrupoRecord,
  QUANTIDADE_INTEGRANTES_GRUPO_REUNIAO_TOOLTIP,
  QUANTIDADE_INTEGRANTES_GRUPO_SAUDE_TOOLTIP,
} from './model-atividadeColetivaGrupos'

interface AtividadeColetivaGruposInfoHeaderProps {
  atividadeColetivaGrupo: AtividadeColetivaGruposModel
}

export const AtividadeColetivaGruposInfoHeader = (props: AtividadeColetivaGruposInfoHeaderProps) => {
  const { atividadeColetivaGrupo } = props
  const classes = styles()

  const isAtividadeSaude =
    atividadeColetivaGrupo.tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.ATIVIDADE_EM_SAUDE

  return (
    <Grid gap={2}>
      <Cell size={3}>
        <HFlow hSpacing={0.5}>
          <InfoLabel title='Nome do grupo' childStyles={classes.breakWord}>
            {atividadeColetivaGrupo.nome}
          </InfoLabel>
          {!atividadeColetivaGrupo.ativo && <Tag>Inativo</Tag>}
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Unidade de saúde'>{atividadeColetivaGrupo.unidadeSaude.nome}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Tipo de grupo'>
          {atividadeColetivaTipoGrupoRecord[atividadeColetivaGrupo.tipoGrupo]}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <HFlow style={classes.integrantesCell}>
          <InfoLabel title='Nº de integrantes'>{atividadeColetivaGrupo.quantidadeIntegrantes}</InfoLabel>
          <InfoIcon
            icon='infoCircleFilled'
            text={
              isAtividadeSaude
                ? QUANTIDADE_INTEGRANTES_GRUPO_SAUDE_TOOLTIP
                : QUANTIDADE_INTEGRANTES_GRUPO_REUNIAO_TOOLTIP
            }
            style={classes.infoIcon}
          />
        </HFlow>
      </Cell>
    </Grid>
  )
}

const styles = () => ({
  integrantesCell: css`
    gap: 0;
  `,
  infoIcon: css`
    margin-top: 0.125rem;
    margin-left: 0.3125rem;
  `,
  breakWord: css`
    word-break: break-word;
  `,
})
